import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* getConsumerDetails() {
  yield takeEvery(actionTypes.GET_CONSUMER_DETAILS, function* (enableLoading) {
    if (enableLoading === true) yield put(actions.enableLoading());
    try {
      const response = yield API.getConsumerDetails();
      if (response.data.success) {
        yield put(actions.getConsumerDetailSuccess(response.data.data));
      } else {
        alert(response.data.message);
      }
      if (enableLoading === true) {
        yield put(actions.disableLoading());
      }
    } catch (error) {
      if (enableLoading === true) {
        yield put(actions.handleAPIError(error));
        yield put(actions.disableLoading());
      }
    }
  });
}
// Profile Details
export function* updateConsumer() {
  yield takeEvery(actionTypes.UPDATE_CONSUMER, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.updateConsumer(action.data);
      if (response.data.success) {
        yield put(actions.updateConsumerSuccess(response.data.data));
      } else {
        alert(response.data.message);

        yield put(actions.updateConsumerFail(response.data.success));
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.updateConsumerFail(false));
      yield put(actions.disableLoading());
    }
  });
}

export function* verifyConsumerAccount() {
  yield takeEvery(actionTypes.VERIFY_CONSUMER_ACC, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.verifyAccount(action.data);
      if (response.data.success) {
        yield put(actions.verifyConsumerAccSuccess(response.data));
      } else {
        alert(response.data.message);
        yield put(actions.verifyConsumerAccSuccess(response.data.success));
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.verifyConsumerAccFail(false));
      yield put(actions.disableLoading());
    }
  });
}

export function* uploadConsumerProfileImg() {
  yield takeEvery(actionTypes.UPLOAD_CONSUMER_IMG, function* (action) {
    yield put(actions.enableLoading());
    let params = new FormData();
    params.append("profile", action.data.profile);
    try {
      const response = yield API.uploadConsumerProfileImg(params);
      if (response.data.success) {
        yield put(actions.uploadConsumerProfileImgSuccess(response.data));
      } else {
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.disableLoading());
    }
  });
}

export function* changePhoneNoSentSMS() {
  yield takeEvery(actionTypes.CHANGE_PHONE_NO_SENT_SMS, function* (action) {
    yield put(actions.enableLoading());

    try {
      const response = yield API.sendSMS(action.data);
      if (response.data.success) {
        yield put(actions.changePhoneNoSentSMSSuccess());
      } else {
        alert(response.data.message);
        yield put(actions.changePhoneNoSentSMSFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.changePhoneNoSentSMSFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* changePhoneNoVerifySMS() {
  yield takeEvery(actionTypes.CHANGE_PHONE_NO_VERIFY_SMS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.verifySMS(action.data);

      if (response.data.success) {
        yield put(actions.changePhoneNoVerifyPhoneSuccess());
      } else {
        alert(response.data.message);
        yield put(actions.changePhoneNoVerifyPhoneFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error));
      yield put(actions.changePhoneNoVerifyPhoneFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* changePhoneNoUpdate() {
  yield takeEvery(actionTypes.CHANGE_PHONE_NO_UPDATE, function* (action) {
    yield put(actions.enableLoading());
    // verifySMS
    try {
      const response = yield API.verifySMS(action.data1);

      if (response.data.success) {
        yield put(actions.changePhoneNoVerifyPhoneSuccess());

        // updatePhone
        try {
          const response2 = yield API.changePhoneNoUpdate(action.data2);
          if (response2.data.success) {
            yield put(actions.changePhoneNoUpdateSuccess());
          } else {
            alert(response2.data.message);
            yield put(actions.changePhoneNoUpdateFail());
          }
          yield put(actions.disableLoading());
        } catch (error) {
          yield put(actions.handleAPIError(error));
          yield put(actions.changePhoneNoUpdateFail());
          yield put(actions.disableLoading());
        }
      } else {
        yield put(actions.disableLoading());
        alert(response.data.message);
        yield put(actions.changePhoneNoVerifyPhoneFail());
      }
    } catch (error) {
      yield put(actions.disableLoading());
      yield put(actions.handleAPIError(error));
      yield put(actions.changePhoneNoVerifyPhoneFail());
    }
  });
}

// Address
export function* getConsumerAddress() {
  yield takeEvery(actionTypes.GET_CONSUMER_ADDRESS, function* () {
    try {
      const response = yield API.getConsumerAddress();
      if (response.data.success) {
        yield put(actions.getConsumerAddressSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getConsumerAddressFail());
      }
    } catch (error) {
      alert(API.constructErrMsg(error));
      yield put(actions.getConsumerAddressFail());
    }
  });
}

export function* addConsumerAddress() {
  yield takeEvery(actionTypes.ADD_CONSUMER_ADDRESS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.addConsumerAddress(action.data);
      if (response.data.success) {
        yield put(actions.addConsumerAddressSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.getConsumerAddress());
      } else {
        alert("Warning: Fail to add address. " + response.data.message);
        yield put(actions.addConsumerAddressFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to add address."));
      yield put(actions.addConsumerAddressFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* updateConsumerAddress() {
  yield takeEvery(actionTypes.UPDATE_CONSUMER_ADDRESS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.updateConsumerAddress(action.data);
      if (response.data.success) {
        yield put(actions.updateConsumerAddressSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.getConsumerAddress());
      } else {
        alert("Warning: Fail to update address. " + response.data.message);
        yield put(actions.updateConsumerAddressFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to update address."));
      yield put(actions.updateConsumerAddressFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* deleteConsumerAddress() {
  yield takeEvery(actionTypes.DELETE_CONSUMER_ADDRESS, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.deleteConsumerAddress(action.data);
      if (response.data.success) {
        yield put(actions.deleteConsumerAddressSuccess());
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.getConsumerAddress());
      } else {
        alert("Warning: Fail to delete address. " + response.data.message);
        yield put(actions.deleteConsumerAddressFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to delete address."));
      yield put(actions.deleteConsumerAddressFail());
      yield put(actions.disableLoading());
    }
  });
}

export function* getDeliveryFee() {
  yield takeEvery(actionTypes.GET_DELIVERY_FEE, function* () {
    try {
      const response = yield API.getDeliveryFee();
      if (response.data.success) {
        yield put(actions.getDeliveryFeeSuccess(response.data.data));
      } else {
        alert(response.data.message);
        yield put(actions.getDeliveryFeeFail());
      }
    } catch (error) {
      alert(API.constructErrMsg(error));
      yield put(actions.getDeliveryFeeFail());
    }
  });
}

// Change Password
export function* changePassword() {
  yield takeEvery(actionTypes.CHANGE_PASSWORD, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.changePassword(action.data);
      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.changePasswordSuccess(action.data.password));
      } else {
        alert("Warning: Fail to change password. " + response.data.message);
        yield put(actions.changePasswordFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to change password."));
      yield put(actions.changePasswordFail());
      yield put(actions.disableLoading());
    }
  });
}

// Notification Settings
export function* setupNofication() {
  yield takeEvery(actionTypes.SETUP_NOTIFICATION, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.setupNotifcation(action.data);
      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.setupNotificationSuccess());
        yield put(actions.getConsumerDetail());
      } else {
        alert(
          "Warning: Fail to update notification settings. " +
            response.data.message
        );
        yield put(actions.setupNotificationFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to  update notification settings.")
      );
      yield put(actions.setupNotificationFail());
      yield put(actions.disableLoading());
    }
  });
}

// Consumer Restaurant Order - My Order
export function* consumerRestaurantOrder() {
  yield takeEvery(actionTypes.RESTAURANT_CONSUMER_ORDER, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.getMyRestaurantOrder(action.data);
      if (response.data.success) {
        yield put(
          actions.consumerGetOrderSuccess(action.status, response.data)
        );
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to load my order"));
      yield put(actions.disableLoading());
    }
  });
}
// Consumer Restaurant Order Details - My Order
export function* consumerRestaurantOrderDetail() {
  yield takeEvery(
    actionTypes.RESTAURANT_CONSUMER_ORDER_DETAIL,
    function* (action) {
      yield put(actions.enableLoading());
      try {
        const response = yield API.getMyRestaurantOrderDetails(action.id);
        if (response.data.success) {
          yield put(actions.consumerOrderDetailSuccess(response.data.data));
        }
        yield put(actions.disableLoading());
      } catch (error) {
        yield put(
          actions.handleAPIError(error, "Fail to load my order detail")
        );
        yield put(actions.disableLoading());
      }
    }
  );
}

// Consumer cancel order restaurant - My Order
export function* consumerRestaurantCancelOrder() {
  yield takeEvery(
    actionTypes.RESTAURANT_CONSUMER_CANCEL_ORDER,
    function* (action) {
      yield put(actions.enableLoading());
      try {
        const response = yield API.cancelMyOrderRestaurant(action.data);
        if (response.data.success) {
          yield put(actions.consumerCancelOrderRestaurantSuccess());
        }
        yield put(actions.disableLoading());
      } catch (error) {
        yield put(actions.handleAPIError(error, "Fail to cancel order"));
        yield put(actions.disableLoading());
      }
    }
  );
}

// Consumer complete order restaurant - My Order
export function* consumerRestaurantCompleteOrder() {
  yield takeEvery(
    actionTypes.RESTAURANT_CONSUMER_COMPLETE_ORDER,
    function* (action) {
      yield put(actions.enableLoading());
      try {
        const response = yield API.completeMyOrderRestaurant(action.id);
        if (response.data.success) {
          yield put(actions.consumerCompleteOrderResSuccess());
        }
        yield put(actions.disableLoading());
      } catch (error) {
        yield put(actions.handleAPIError(error, "Fail to complete order"));
        yield put(actions.disableLoading());
      }
    }
  );
}

// Restaurant order review - My Order
export function* consumerRestaurantOrderReview() {
  yield takeEvery(actionTypes.RESTAURANT_ORDER_REVIEW, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.reviewRestaurantWithImage(
        action.rid,
        action.orderID,
        action.data
      );
      if (response.data.success) {
        yield put(actions.restaurantOrderReviewSuccess());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to review restaurant"));
      yield put(actions.disableLoading());
    }
  });
}

// Restaurant Order Rider Review - My Order
export function* consumerResOrderRiderReview() {
  yield takeEvery(
    actionTypes.RESTAURANT_ORDER_RIDER_REVIEW,
    function* (action) {
      yield put(actions.enableLoading());
      try {
        const response = yield API.reviewRestaurantWithImage(
          action.rid,
          action.orderID,
          action.dataShop
        );
        if (response.data.success) {
          try {
            const response1 = yield API.riderReview(
              action.orderID,
              action.riderID,
              action.dataRider
            );
            if (response1.data.success) {
              yield put(actions.restaurantRiderReviewSuccess());
            }
          } catch (error) {
            yield put(actions.handleAPIError(error, "Fail to review rider"));
            yield put(actions.disableLoading());
          }
        }
        yield put(actions.disableLoading());
      } catch (error) {
        yield put(actions.handleAPIError(error, "Fail to review restaurant"));
        yield put(actions.disableLoading());
      }
    }
  );
}

// Wallet Pin
export function* setWalletPin() {
  yield takeEvery(actionTypes.SET_WALLET_PIN, function* (action) {
    yield put(actions.enableLoading());
    try {
      const response = yield API.setWalletPin(action.data);

      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.setWalletPinSuccess());
        yield put(actions.getConsumerDetail());
      } else {
        alert("Warning: Fail to set wallet pin. " + response.data.message);
        yield put(actions.setWalletPinFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(actions.handleAPIError(error, "Fail to set wallet pin."));
      yield put(actions.setWalletPinFail());
      yield put(actions.disableLoading());
    }
  });
}

// Become Merchant
export function* becomeMerchant() {
  yield takeEvery(actionTypes.BECOME_MERCHANT, function* (action) {
    yield put(actions.enableLoading());
    // Upload Document
    try {
      const uploadDocumentResponse = yield API.uploadbecomeMerchantDocument(
        action.documents
      );
      if (
        uploadDocumentResponse.data.success &&
        uploadDocumentResponse.data.data
      ) {
        try {
          let params = { ...action.data };
          if (params.business_uuid === undefined) {
            params.business_uuid = uploadDocumentResponse.data.data;
          }

          const response = yield API.submitBecomeMerchant(params);

          if (response.data.success) {
            yield put(actions.toastSuccess(response.data.message));
            yield put(actions.becomerMerchantSuccess());
          } else {
            alert(
              "Warning: Fail to submit become merchant data. \n" +
                response.data.message
            );
            yield put(actions.becomerMerchantFail());
          }
          yield put(actions.disableLoading());
        } catch (error) {
          yield put(
            actions.handleAPIError(
              error,
              "Fail to upload become merchant document."
            )
          );
          yield put(actions.becomerMerchantFail());
          yield put(actions.disableLoading());
        }
        // yield put(actions.consumerCancelOrderRestaurantSuccess());
      } else {
        alert(
          "Warning: Fail to upload become merchant document. \n" +
            uploadDocumentResponse.data.message
        );
        yield put(actions.becomerMerchantFail());
        yield put(actions.disableLoading());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(
          error,
          "Fail to upload become merchant document."
        )
      );
      yield put(actions.becomerMerchantFail());
      yield put(actions.disableLoading());
    }
  });
}

// Become Merchant V2
export function* becomeMerchant_two() {
  yield takeEvery(actionTypes.BECOME_MERCHANT_TWO, function* (action) {
    // console.log(action);
    yield put(actions.enableLoading());
    // Upload Document
    try {
      let params = { ...action.data };
      const response = yield API.submitBecomeMerchant_Two(params);
      //   console.log(response);
      if (response.data.success) {
        yield put(actions.toastSuccess(response.data.message));
        yield put(actions.becomerMerchantTwoSuccess(response.data.case_id));
      } else {
        alert(
          "Warning: Fail to submit become merchant data. \n" +
            response.data.message
        );
        yield put(actions.becomerMerchantTwoFail());
      }
      yield put(actions.disableLoading());
    } catch (error) {
      yield put(
        actions.handleAPIError(
          error,
          "Fail to upload become merchant document."
        )
      );
      yield put(actions.becomerMerchantTwoFail());
      yield put(actions.disableLoading());
    }
  });
}

// Product Preference
export function* setProductPreference() {
  yield takeEvery(actionTypes.SET_PRODUCT_PREFERENCE, function* (action) {
    try {
      const response = yield API.setProductPreference(action.data);
      if (response.data.success) {
        if (action.toastSuccess === true) {
          yield put(actions.toastSuccess(response.data.message));
          yield put(actions.getConsumerDetail());
        }
        yield put(actions.setProductPreferenceSuccess(action.data));
      } else {
        alert(
          "Warning: Fail to set product preference. " + response.data.message
        );
        yield put(actions.setProductPreferenceFail());
      }
    } catch (error) {
      yield put(
        actions.handleAPIError(error, "Fail to set product preference.")
      );
      yield put(actions.setProductPreferenceFail());
    }
  });
}

export default function* consumerSaga() {
  yield all([
    // Profile Details
    fork(getConsumerDetails),
    fork(updateConsumer),
    fork(verifyConsumerAccount),
    fork(uploadConsumerProfileImg),
    fork(changePhoneNoSentSMS),
    fork(changePhoneNoVerifySMS),
    fork(changePhoneNoUpdate),
    // Address
    fork(getConsumerAddress),
    fork(addConsumerAddress),
    fork(updateConsumerAddress),
    fork(deleteConsumerAddress),
    fork(getDeliveryFee),
    // Change Password
    fork(changePassword),
    fork(setupNofication),
    // My Order
    fork(consumerRestaurantOrder),
    fork(consumerRestaurantOrderDetail),
    fork(consumerRestaurantCancelOrder),
    fork(consumerRestaurantCompleteOrder),
    fork(consumerRestaurantOrderReview),
    fork(consumerResOrderRiderReview),
    // Walet Pin
    fork(setWalletPin),
    // Become Merchant
    fork(becomeMerchant),
    fork(becomeMerchant_two),
    // Product Preference
    fork(setProductPreference),
  ]);
}
